import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { combineReducers, createStore } from 'redux'
import App from './App'
import './index.css'
import reportWebVitals from './reportWebVitals'
import languageReducer from './store/languageReducer'
// const store = configureStore({
//    reducer: languageReducer,
// })
const store = createStore(
   combineReducers({
      languageReducer,
   }),
   // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
)

const root: any = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
   //<React.StrictMode>
   <Provider store={store}>
      <App />
   </Provider>,
   //</React.StrictMode>,
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
